import { StarIcon } from "@heroicons/react/24/solid";
import OwlCarousel from "react-owl-carousel";
export default function MoreBlog() {
  const options = {
    loop: true,
    // marginLeft: 30,
    nav: true,

    dots: false,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      1000: {
        items: 2,
      },
    },
  };

  return (
    <div className="mt-10">
      <div className="md:grid md:grid-cols-12 md:gap-x-5 sm:gap-x-0">
        <div className="md:col-span-3  hidden md:block">
          <a
            href="#"
            target="_blank"
            rel="noreferrer"
            className="block h-[620px] w-full overflow-hidden"
          >
            <img
              src="https://i.pinimg.com/736x/52/36/60/523660b28f86acc07bf325ee3599ae25.jpg"
              alt="Advertisement"
              className="h-full w-full object-cover"
            />
          </a>
        </div>
        <div className="md:col-span-9 sm:col-span-1 ">
          <OwlCarousel
            margin={5}
            navText={["<", ">"]}
            className="owl-theme"
            {...options}
          >
            <div className="h-[621px] border">
              <img src="/blog-details/blog-details-img2.png" alt="" />
              <div className=" p-[36px]">
                <h1 className="text-[28px] font-bold">
                  Why Use A Resume Builder in 2024?
                </h1>
                <p className="mt-5">
                  Let's explore the benefits of using a online resume builder in
                  2024 and how it can give you a competitive edge in your job
                  search.
                </p>
                <div className="mb-[15px] flex justify-between">
                  <button className="text-[#ff1303] mt-5 ">Read Story</button>
                  <div className="flex">
                    <StarIcon className="starIcon-5" />
                    <StarIcon className="starIcon-5" />
                    <StarIcon className="starIcon-5" />
                    <StarIcon className="starIcon-5" />
                    <StarIcon className="starIcon-5" />
                  </div>
                </div>
              </div>
              <hr className="border-[#e9eef1]  " />
              <div className="mt-3 flex justify-between px-3">
  {/* Rounded full background & border সহ Careerflow Team badge */}
  <div className="flex items-center gap-2 rounded-full border border-gray-300 bg-[#e9eef1] px-3 py-1">
    <img
      src="/blog-details/blog-img-details.png"
      className="blog_iconImg h-9 w-auto object-contain"
      alt="Careerflow Team"
    />
      <p className="font-bold">Careerflow Team</p>
  </div>   

  {/* Job search button (অপরিবর্তিত) */}
  <button className="bg-[#fc1c26] text-white px-1 rounded text-[12px]">
    Job search
  </button>
</div>
            </div>
            <div className="h-[621px] border">
              <img src="/blog-details/blog-details-img2.png" alt="" />
              <div className=" p-[36px]">
                <h1 className="text-[28px] font-bold">
                  Why Use A Resume Builder in 2024?
                </h1>
                <p className="mt-5">
                  Let's explore the benefits of using a online resume builder in
                  2024 and how it can give you a competitive edge in your job
                  search.
                </p>
                <div className="mb-[15px] flex justify-between">
                  <button className="text-[#ff1303] mt-5 ">Read Story</button>
                  <div className="flex">
                    <StarIcon className="starIcon-5" />
                    <StarIcon className="starIcon-5" />
                    <StarIcon className="starIcon-5" />
                    <StarIcon className="starIcon-5" />
                    <StarIcon className="starIcon-5" />
                  </div>
                </div>
              </div>
              <hr className="border-[#e9eef1]" />
              <div className="mt-3 flex justify-between px-3">
  {/* Rounded full background & border সহ Careerflow Team badge */}
  <div className="flex items-center gap-2 rounded-full border border-gray-300 bg-[#e9eef1] px-3 py-1">
    <img
      src="/blog-details/blog-img-details.png"
      className="blog_iconImg h-9 w-auto object-contain"
      alt="Careerflow Team"
    />
      <p className="font-bold">Careerflow Team</p>
  </div>   

  {/* Job search button (অপরিবর্তিত) */}
  <button className="bg-[#fc1c26] text-white px-1 rounded text-[12px]">
    Job search
  </button>
</div>
            </div>
            <div className="h-[621px] border">
              <img src="/blog-details/blog-details-img2.png" alt="" />
              <div className=" p-[36px]">
                <h1 className="text-[28px] font-bold">
                  Why Use A Resume Builder in 2024?
                </h1>
                <p className="mt-5">
                  Let's explore the benefits of using a online resume builder in
                  2024 and how it can give you a competitive edge in your job
                  search.
                </p>
                <div className="mb-[15px] flex justify-between">
                  <button className="text-[#ff1303] mt-5 ">Read Story</button>
                  <div className="flex">
                    <StarIcon className="starIcon-5" />
                    <StarIcon className="starIcon-5" />
                    <StarIcon className="starIcon-5" />
                    <StarIcon className="starIcon-5" />
                    <StarIcon className="starIcon-5" />
                  </div>
                </div>
              </div>
              <hr className="border-[#e9eef1]" />
              <div className="mt-3 flex justify-between px-3">
  {/* Rounded full background & border সহ Careerflow Team badge */}
  <div className="flex items-center gap-2 rounded-full border border-gray-300 bg-[#e9eef1] px-3 py-1">
    <img
      src="/blog-details/blog-img-details.png"
      className="blog_iconImg h-9 w-auto object-contain"
      alt="Careerflow Team"
    />
      <p className="font-bold">Careerflow Team</p>
  </div>   

  {/* Job search button (অপরিবর্তিত) */}
  <button className="bg-[#fc1c26] text-white px-2 rounded text-[14px]">
    Job search
  </button>
</div>
            </div>
          </OwlCarousel>
        </div>
      </div>
    </div>
  );
}
